import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'app-primary-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: '../base-button/base-button.component.html',
  styleUrls: ['../base-button/base-button.component.scss', './primary-button.component.scss']
})
export class PrimaryButtonComponent extends BaseButtonComponent {}
